import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom';
import { getAdminProfile } from '../services/adminApi.ts';

const ProtectedAdminRoute: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [userType, setUserType] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      console.log('Checking authentication...');
      const token = localStorage.getItem('admin_token');
      console.log('Token exists:', !!token);
      
      if (!token) {
        console.log('No token found, redirecting to login');
        setIsAuthenticated(false);
        return;
      }

      try {
        console.log('Fetching user profile...');
        const response = await getAdminProfile();
        console.log('Profile response:', response);
        
        setIsAuthenticated(true);
        setUserType(response.userType);
        
        // Store the user type and profile in localStorage
        localStorage.setItem('user_type', response.userType);
        localStorage.setItem('admin_user', JSON.stringify(response.profile));
        
        console.log('Current path:', location.pathname);
        console.log('User type:', response.userType);
        
        // No need to redirect based on user type anymore since we're using the same dashboard
      } catch (err) {
        console.error('Authentication error:', err);
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        localStorage.removeItem('user_type');
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, [navigate, location.pathname]);

  if (isAuthenticated === null) {
    return <div>Loading authentication status...</div>;
  }

  if (isAuthenticated) {
    console.log('User is authenticated, rendering outlet');
    return <Outlet />;
  }

  console.log('User is not authenticated, redirecting to login');
  return <Navigate to="/admin/login" />;
};

export default ProtectedAdminRoute; 